import { render, staticRenderFns } from "./TabelaAjusteRateios.vue?vue&type=template&id=4a9b0e7a"
import script from "./TabelaAjusteRateios.vue?vue&type=script&lang=js"
export * from "./TabelaAjusteRateios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports